import React, { useEffect } from "react";
import moment from "moment";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Datetime from "react-datetime";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "../../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styles2 from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { useDispatch, useSelector } from "react-redux";
import {
  CLEAR_ERROR,
  VISA_APPLICANT_DELETE_REQUESTED,
  VISA_APPLICANT_GET_ALL_REQUESTED,
  VISA_APPLICANT_LOG_GET_REQUESTED,
  VISA_APPLICANT_UPDATE_REQUESTED,
} from "../../../redux/actions";
import {
  convertDate,
  getAnzsco,
  getDropDown,
  getOccupation,
  getUserName,
  labelStyleFunc,
  isValidVisaApplicantInputs,
} from "../../../scripts/util";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";
import Muted from "../../../components/Typography/Muted";
import ReactGA from "react-ga4";
import {
  DEFAULT_DATE_FORMAT,
  GENERAL_ROLE,
  nominationStatus,
  occupationCodeOption,
  SUPER_ADMIN_ROLES,
  useGetOccupationOptions,
  useGetVisaTypeOptions,
  TINY_INIT,
} from "../../../scripts/const";
import CustomLinearProgress from "../../../components/CustomLinearProgress/CustomLinearProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import SweetAlert from "react-bootstrap-sweetalert";
import { Editor } from "@tinymce/tinymce-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import { default as ReactSelect } from "react-select";
import DropDownWithSearch, {
  customReactSelectStyles,
} from "../../../components/DropDownWithSearch/DropDownWithSearch";
import FileUpload from "../../../components/CustomUpload/FileUpload";
import { useQueryClient } from "@tanstack/react-query";
import { GET_VISA_APPLICANTS_QUERY } from "api/visaApplicant.js";

const useStyles = makeStyles({ ...styles, ...styles2 });

export default function EditVisa(props) {
  const { roleId: currentRoleId } = useSelector(
    (state) => state.login.loginUser.detail
  );
  const occupationOption = useGetOccupationOptions();
  const visaTypeOption = useGetVisaTypeOptions();
  const isGeneralUser = GENERAL_ROLE.includes(currentRoleId);
  const [error, setError] = React.useState(false);
  const [validationErrMsg, setValidationErrMsg] = React.useState(null);
  const [success, setSuccess] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [visaApplicant, setVisaApplicant] = React.useState({});
  const [visaApplicantCopy, setVisaApplicantCopy] = React.useState({});
  const [visaLog, setVisaLog] = React.useState([]);
  const [isLog, setIsLog] = React.useState(false);
  const sLog = useSelector((state) => state.visaApplicant.visaApplicantLog);
  const [logId, setLogId] = React.useState(null);

  const handleFileUpload = (fileUrl) => {
    if (!visaApplicant.files) {
      setVisaApplicant({
        ...visaApplicant,
        files: [fileUrl],
      });
    } else {
      setVisaApplicant({
        ...visaApplicant,
        files: [...visaApplicant.files, fileUrl],
      });
    }
  };

  const handleFileDelete = (fileUrl) => {
    setVisaApplicant({
      ...visaApplicant,
      files: visaApplicant.files.filter((f) => f != fileUrl),
    });
  };

  useEffect(() => {
    setVisaLog(sLog);
  }, [sLog]);

  const handleLog = () => {
    if (isLog) {
      setVisaApplicant(visaApplicantCopy);
    } else {
      ReactGA.event({
        category: "ViewHistory",
        action: "View Visa Applicant History",
      });
      setVisaApplicantCopy(visaApplicant);
    }
    if (!isLog && visaLog.length === 0) {
      dispatch({
        type: VISA_APPLICANT_LOG_GET_REQUESTED,
        payload: visaApplicantId,
      });
    }
    setIsLog(!isLog);
  };

  const [visaApplicantId, setVisaApplicantId] = React.useState(false);
  const [errMessage, setErrorMsg] = React.useState(
    "Something went wrong. Please try again."
  );
  const errMsg = useSelector((state) => state.visaApplicant.errorMsg);
  useEffect(() => {
    setErrorMsg(errMsg);
  }, [errMsg]);
  const handleSelect = (e) => {
    setVisaApplicant({
      ...visaApplicant,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditorChange = (content) => {
    setVisaApplicant({
      ...visaApplicant,
      remarks: content,
    });
  };

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const editError = useSelector(
    (state) => state.visaApplicant.visaApplicantUpdateError
  );
  const editProgress = useSelector(
    (state) => state.visaApplicant.visaApplicantUpdateFetching
  );
  const editSuccess = useSelector(
    (state) => state.visaApplicant.visaApplicantUpdateSuccess
  );

  const deleteProgress = useSelector(
    (state) => state.visaApplicant.visaApplicantDeleteFetching
  );
  const deleteSuccess = useSelector(
    (state) => state.visaApplicant.visaApplicantDeleteSuccess
  );

  function clearErrors() {
    setValidationErrMsg("");
  }

  useEffect(() => {
    setModalOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    if (!modalOpen) {
      clearErrors();
      setVisaApplicant(visaApplicantCopy);
      setVisaLog([]);
      setIsLog(false);
      setLogId(null);
      hideAlert();
    }
  }, [modalOpen]);

  useEffect(() => {
    setValidationErrMsg("");
    dispatch({ type: CLEAR_ERROR });
  }, []);

  useEffect(() => {
    setVisaApplicant(props.visaApplicant);
    setVisaApplicantId(props.visaApplicant.id);
  }, [props.visaApplicant, props.open]);

  useEffect(() => {
    setError(editError);
  }, [editError]);

  useEffect(() => {
    setSuccess(editSuccess);
  }, [editSuccess]);

  useEffect(() => {
    if (editSuccess === true || deleteSuccess === true) {
      setTimeout(() => {
        if (deleteSuccess) {
          props.handleSuccess(false);
        }
      }, 720);
      setTimeout(() => {
        // setVisaApplicant({});
        dispatch({ type: CLEAR_ERROR });
      }, 750);

      // invalidate visa query
      queryClient.invalidateQueries({ queryKey: [GET_VISA_APPLICANTS_QUERY] });
    }
  }, [editSuccess, deleteSuccess]);

  const handleDatePicker = (date, name) => {
    if (moment.isMoment(date)) {
      if (name === "requestedDate") {
        setVisaApplicant({
          ...visaApplicant,
          [name]: date.format(DEFAULT_DATE_FORMAT).toString(),
          dueDate: date
            .clone()
            .add(27, "days")
            .format(DEFAULT_DATE_FORMAT)
            .toString(),
        });
      } else if (
        name === "statusDate" &&
        visaApplicant.status === "Nomination Lodged"
      ) {
        setVisaApplicant({
          ...visaApplicant,
          [name]: date.format(DEFAULT_DATE_FORMAT).toString(),
          nominationLodged: date.format(DEFAULT_DATE_FORMAT).toString(),
        });
      } else if (
        name === "statusDate" &&
        visaApplicant.status === "Visa Applied"
      ) {
        setVisaApplicant({
          ...visaApplicant,
          [name]: date.format(DEFAULT_DATE_FORMAT).toString(),
          visaSubmitted: date.format(DEFAULT_DATE_FORMAT).toString(),
        });
      } else if (
        name === "statusDate" &&
        visaApplicant.status === "Visa Granted"
      ) {
        setVisaApplicant({
          ...visaApplicant,
          [name]: date.format(DEFAULT_DATE_FORMAT).toString(),
          visaGranted: date.format(DEFAULT_DATE_FORMAT).toString(),
        });
      } else if (
        name === "statusDate" &&
        ["Nomination Approved", "Nomination Refused"].includes(
          visaApplicant.status
        )
      ) {
        setVisaApplicant({
          ...visaApplicant,
          [name]: date.format(DEFAULT_DATE_FORMAT).toString(),
          nominationDecision: date.format(DEFAULT_DATE_FORMAT).toString(),
        });
      } else {
        setVisaApplicant({
          ...visaApplicant,
          [name]: date.format(DEFAULT_DATE_FORMAT).toString(),
        });
      }
    } else {
      setVisaApplicant({
        ...visaApplicant,
        [name]: date,
      });
    }
  };

  function editVisaApplicant() {
    const errors = isValidVisaApplicantInputs(visaApplicant);
    if (errors.length > 0) {
      setValidationErrMsg(errors);
      dispatch({ type: CLEAR_ERROR });
    } else {
      setValidationErrMsg("");
      dispatch({
        type: VISA_APPLICANT_UPDATE_REQUESTED,
        payload: { payload: visaApplicant, id: visaApplicantId },
      });
    }
  }

  function getLog() {
    return visaLog.map((st, index) => (
      <Card key={index} color={index === logId ? "primary" : null}>
        <CardBody
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            setLogId(index);
            setVisaApplicant(visaLog[index]);
          }}
        >
          <small>{getUserName(st.updatedBy, props.allUsers)}</small>
          <br></br>
          <small>{convertDate(st.version_timestamp)}</small>
        </CardBody>
      </Card>
    ));
  }

  function deleteEntity() {
    dispatch({
      type: VISA_APPLICANT_DELETE_REQUESTED,
      payload: { id: visaApplicantId },
    });
    ReactGA.event({
      category: "VisaService",
      action: "Deleted a Visa Applicant",
    });
  }

  const [alert, setAlert] = React.useState(null);
  const hideAlert = () => {
    setAlert(null);
  };

  const successDelete = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Deleted!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      />
    );
  };
  const confirmationMessage = () => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => {
          deleteEntity();
          successDelete();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      />
    );
  };
  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem
          style={{
            textAlign: "right",
          }}
          xs={12}
          sm={12}
          md={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={isLog}
                onChange={handleLog}
                value={isLog}
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.switchChecked,
                  thumb: classes.switchIcon,
                  track: classes.switchBar,
                }}
              />
            }
            classes={{
              label: classes.label,
            }}
            label={isLog ? "HideHistory" : "ShowHistory"}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={3} sm={3} md={3}>
          {isLog && <div>{getLog()}</div>}
        </GridItem>
        <GridItem xs={isLog ? 9 : 12} sm={isLog ? 9 : 12} md={isLog ? 9 : 12}>
          <Card>
            <CardBody className="d-flex flex-column gap-3">
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  {validationErrMsg && (
                    <SnackbarContent
                      message={validationErrMsg}
                      color="warning"
                    />
                  )}
                  {editProgress && <CustomLinearProgress color="primary" />}
                  {error && (
                    <SnackbarContent message={errMessage} color="warning" />
                  )}
                  {success && (
                    <SnackbarContent
                      message="Updated the visa applicant"
                      color="success"
                    />
                  )}
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="ID"
                    id="editVisa-id"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicantId || "",
                      disabled: true,
                      name: "id",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Email address *"
                    id="visa-edit-email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicant.email || "",
                      onChange: handleSelect,
                      name: "email",
                      type: "email",
                      disabled: isLog,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Phone Number *"
                    id="visa-edit-phone"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicant.phone || "",
                      onChange: handleSelect,
                      name: "phone",
                      disabled: isLog,
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="First Name *"
                    id="visa-edit-firstName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicant.firstName || "",
                      onChange: handleSelect,
                      name: "firstName",
                      disabled: isLog,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Middle Name"
                    id="visa-edit-middleName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicant.middleName || "",
                      onChange: handleSelect,
                      name: "middleName",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Last Name *"
                    id="visa-edit-lastName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicant.lastName || "",
                      onChange: handleSelect,
                      name: "lastName",
                      disabled: isLog,
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <InputLabel className={classes.label}>
                    Date of Birth
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.dob || ""}
                      onChange={(moment) => handleDatePicker(moment, "dob")}
                      inputProps={{
                        name: "dob",
                        id: "edit-visa-dob-date",
                        placeholder: DEFAULT_DATE_FORMAT,
                        disabled: isLog,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <DropDownWithSearch
                    optionsList={getDropDown("country")}
                    selectedOption={visaApplicant.country || ""}
                    setValue={setVisaApplicant}
                    currentState={visaApplicant}
                    name={"country"}
                    label={"Country"}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Passport No"
                    id="visa-edit-passport"
                    type="number"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicant.passport,
                      onChange: handleSelect,
                      name: "passport",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <InputLabel className={classes.label}>Issue Date</InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.issueDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "issueDate")
                      }
                      inputProps={{
                        name: "issueDate",
                        id: "visa-edit-issueDate",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <InputLabel className={classes.label}>
                    Visa Expiry Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.expiryDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "expiryDate")
                      }
                      inputProps={{
                        name: "expiryDate",
                        id: "visa-edit-expiryDate",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <FormControl fullWidth>
                    <div
                      className={classes.label}
                      style={labelStyleFunc(visaApplicant.currentVisa)}
                    >
                      Current Visa
                    </div>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      isDisabled={isLog}
                      value={
                        visaApplicant.currentVisa
                          ? {
                              label: visaApplicant.currentVisa,
                              value: visaApplicant.currentVisa,
                            }
                          : ""
                      }
                      styles={customReactSelectStyles}
                      options={visaTypeOption}
                      name="currentVisa"
                      placeholder={"Current Visa"}
                      onChange={(options) => {
                        if (!options) {
                          setVisaApplicant({
                            ...visaApplicant,
                            currentVisa: "",
                          });
                        } else {
                          setVisaApplicant({
                            ...visaApplicant,
                            currentVisa: options.value,
                          });
                        }
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <InputLabel className={classes.label}>
                    Visa Expiry Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.visaExpiry || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "visaExpiry")
                      }
                      inputProps={{
                        name: "visaExpiry",
                        id: "visaExpiry-edit",
                        placeholder: DEFAULT_DATE_FORMAT,
                        disabled: isLog,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <FormControl fullWidth>
                    <div
                      className={classes.label}
                      style={labelStyleFunc(visaApplicant.proposedVisa)}
                    >
                      Proposed Visa
                    </div>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      isDisabled={isLog}
                      value={
                        visaApplicant.proposedVisa
                          ? {
                              label: visaApplicant.proposedVisa,
                              value: visaApplicant.proposedVisa,
                            }
                          : ""
                      }
                      styles={customReactSelectStyles}
                      options={visaTypeOption}
                      name="proposedVisa"
                      placeholder={"Proposed Visa"}
                      onChange={(options) => {
                        if (!options) {
                          setVisaApplicant({
                            ...visaApplicant,
                            proposedVisa: "",
                          });
                        } else {
                          setVisaApplicant({
                            ...visaApplicant,
                            proposedVisa: options.value,
                          });
                        }
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <FormControl fullWidth>
                    <div
                      className={classes.label}
                      style={labelStyleFunc(visaApplicant.occupation)}
                    >
                      Occupation
                    </div>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      value={
                        visaApplicant.occupation
                          ? {
                              label: visaApplicant.occupation,
                              value: visaApplicant.occupation,
                            }
                          : ""
                      }
                      styles={customReactSelectStyles}
                      options={occupationOption}
                      name="occupation"
                      placeholder={"Occupation"}
                      onChange={(options) => {
                        if (!options) {
                          setVisaApplicant({
                            ...visaApplicant,
                            occupation: "",
                            anzsco: "",
                          });
                        } else {
                          setVisaApplicant({
                            ...visaApplicant,
                            occupation: options.value,
                            anzsco: getAnzsco(options.value),
                          });
                        }
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <FormControl fullWidth>
                    <div
                      className={classes.label}
                      style={labelStyleFunc(visaApplicant.anzsco)}
                    >
                      ANZSCO
                    </div>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      value={
                        visaApplicant.anzsco
                          ? {
                              label: visaApplicant.anzsco,
                              value: visaApplicant.anzsco,
                            }
                          : ""
                      }
                      styles={customReactSelectStyles}
                      options={occupationCodeOption}
                      name="anzsco"
                      placeholder={"ANZSCO"}
                      onChange={(options) => {
                        if (!options) {
                          setVisaApplicant({
                            ...visaApplicant,
                            anzsco: "",
                            occupation: "",
                          });
                        } else {
                          setVisaApplicant({
                            ...visaApplicant,
                            anzsco: options.value,
                            occupation: getOccupation(options.value),
                          });
                        }
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Invoice Number"
                    id="edit-visa-invoiceNumber"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicant.invoiceNumber || "",
                      onChange: handleSelect,
                      name: "invoiceNumber",
                      disabled: isLog,
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Payment"
                    id="edit-visa-payment"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: visaApplicant.payment || "",
                      onChange: handleSelect,
                      name: "payment",
                      disabled: isLog,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <DropDownWithSearch
                    optionsList={getDropDown("payment-status")}
                    selectedOption={visaApplicant.paymentStatus || ""}
                    setValue={setVisaApplicant}
                    currentState={visaApplicant}
                    name={"paymentStatus"}
                    label={"Payment Status"}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <DropDownWithSearch
                    optionsList={getDropDown("visa-csa-status")}
                    selectedOption={visaApplicant.csaStatus || ""}
                    setValue={setVisaApplicant}
                    currentState={visaApplicant}
                    name={"csaStatus"}
                    label={"CSA Status"}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <FormControl fullWidth>
                    <div
                      className={classes.label}
                      style={labelStyleFunc(visaApplicant.nominationStatus)}
                    >
                      Nomination Status
                    </div>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      value={
                        visaApplicant.nominationStatus
                          ? {
                              label: visaApplicant.nominationStatus,
                              value: visaApplicant.nominationStatus,
                            }
                          : ""
                      }
                      styles={customReactSelectStyles}
                      options={nominationStatus}
                      name="nominationStatus"
                      placeholder={"Nomination Status"}
                      onChange={(options) => {
                        if (!options) {
                          setVisaApplicant({
                            ...visaApplicant,
                            nominationStatus: "",
                          });
                        } else {
                          setVisaApplicant({
                            ...visaApplicant,
                            nominationStatus: options.value,
                          });
                        }
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <DropDownWithSearch
                    optionsList={getDropDown("visa-state")}
                    selectedOption={visaApplicant.state || ""}
                    setValue={setVisaApplicant}
                    currentState={visaApplicant}
                    name={"state"}
                    label={"State"}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>
                    Nomination Lodged
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.nominationLodged || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "nominationLodged")
                      }
                      inputProps={{
                        name: "nominationLodged",
                        id: "edit-visa-nominationLodged",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>
                    Nomination Decision
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.nominationDecision || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "nominationDecision")
                      }
                      inputProps={{
                        name: "nominationDecision",
                        id: "edit-visa-nominationDecision",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>
                    Visa Submitted Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      autoOk
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.visaSubmitted || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "visaSubmitted")
                      }
                      inputProps={{
                        name: "visaSubmitted",
                        id: "visaSubmitted-edit",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>
                    Visa Grant Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.visaGranted || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "visaGranted")
                      }
                      inputProps={{
                        name: "visaGranted",
                        id: "visaGranted-edit",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>
                    Requested Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.requestedDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "requestedDate")
                      }
                      inputProps={{
                        name: "requestedDate",
                        id: "requestedDate-edit",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>Due Date</InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={visaApplicant.dueDate || ""}
                      onChange={(moment) => handleDatePicker(moment, "dueDate")}
                      inputProps={{
                        name: "dueDate",
                        id: "dueDate-edit",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <DropDownWithSearch
                    optionsList={getDropDown("location")}
                    selectedOption={visaApplicant.location || ""}
                    setValue={setVisaApplicant}
                    currentState={visaApplicant}
                    name={"location"}
                    label={"Location"}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  {props.allSources && (
                    <DropDownWithSearch
                      dbOptions={props.allSources}
                      selectedOption={visaApplicant.sourceId || ""}
                      setValue={setVisaApplicant}
                      currentState={visaApplicant}
                      name={"sourceId"}
                      label={"Source"}
                    />
                  )}
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <DropDownWithSearch
                    optionsList={getDropDown("visa-status")}
                    selectedOption={visaApplicant.status || ""}
                    setValue={setVisaApplicant}
                    currentState={visaApplicant}
                    name={"status"}
                    label={"Status *"}
                  />
                </GridItem>
                {visaApplicant.status &&
                  [
                    "Nomination Lodged",
                    "Nomination Approved",
                    "Nomination Refused",
                    "Visa Applied",
                    "Info Requested",
                    "Visa Granted",
                    "Visa Rejected",
                    "Withdrawn",
                  ].includes(visaApplicant.status) && (
                    <GridItem xs={12} sm={12} md={3}>
                      <InputLabel className={classes.label}>
                        {visaApplicant.status} Date *
                      </InputLabel>

                      <FormControl fullWidth>
                        <Datetime
                          closeOnSelect
                          timeFormat={false}
                          dateFormat={DEFAULT_DATE_FORMAT}
                          value={visaApplicant.statusDate || ""}
                          onChange={(moment) =>
                            handleDatePicker(moment, "statusDate")
                          }
                          inputProps={{
                            name: "statusDate",
                            id: "edit-visa-statusDate",
                            placeholder: DEFAULT_DATE_FORMAT,
                          }}
                        />
                      </FormControl>
                    </GridItem>
                  )}
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  {props.allUsers && (
                    <DropDownWithSearch
                      dbOptions={props.allUsers}
                      dbLabel={"firstName"}
                      selectedOption={visaApplicant.userId || ""}
                      setValue={setVisaApplicant}
                      currentState={visaApplicant}
                      name={"userId"}
                      label={"Assigned To"}
                    />
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <h4>Note:</h4>
                  <Editor
                    licenseKey={"gpl"}
                    tinymceScriptSrc={
                      "https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.1.2/tinymce.min.js"
                    }
                    value={visaApplicant.remarks || ""}
                    init={TINY_INIT}
                    onEditorChange={handleEditorChange}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem>
                  <div>
                    <h4>Documents:</h4>
                    <FileUpload
                      autoUpload
                      uploadOnly
                      label={"Upload new file"}
                      type={"visa"}
                      setFileUrl={(fileUrl) => handleFileUpload(fileUrl)}
                    />
                  </div>
                </GridItem>
              </GridContainer>
              <GridContainer>
                {visaApplicant.files &&
                  visaApplicant.files.length > 0 &&
                  visaApplicant.files.map((fileUrl, id) => {
                    return (
                      <GridItem key={id}>
                        <div
                          style={{
                            flexDirection: "column",
                            display: "flex",
                            backgroundColor: "#B0BEC5",
                            padding: "20px",
                            borderRadius: "25px",
                            marginTop: "10px",
                          }}
                        >
                          <FileUpload
                            fileUrl={fileUrl}
                            key={id}
                            handleDelete={(fileUrl) => {
                              handleFileDelete(fileUrl);
                            }}
                          />
                        </div>
                      </GridItem>
                    );
                  })}
              </GridContainer>

              <GridContainer
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <GridItem>
                  <Muted>
                    Updated At: {convertDate(visaApplicant.updatedAt)}
                  </Muted>
                  <Muted>
                    Updated By:{" "}
                    {getUserName(visaApplicant.updatedBy, props.allUsers)}
                  </Muted>
                </GridItem>
                <GridItem
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.3rem",
                  }}
                >
                  {editProgress && <CircularProgress size={"2rem"} />}
                  {error && <CloseIcon style={{ color: "red" }} />}
                  {success && <CheckIcon style={{ color: "green" }} />}
                  {SUPER_ADMIN_ROLES.includes(currentRoleId) && (
                    <Button
                      color="danger"
                      disabled={!!(deleteProgress || isLog)}
                      className={classes.moveToRight}
                      onClick={(e) => {
                        e.preventDefault();
                        confirmationMessage();
                      }}
                    >
                      Delete
                    </Button>
                  )}
                  <Button
                    color="primary"
                    disabled={editProgress || isLog ? true : false}
                    className={classes.moveToRight}
                    onClick={(e) => {
                      ReactGA.event({
                        category: "VisaService",
                        action: "Updated a Visa Applicant",
                      });
                      e.preventDefault();
                      editVisaApplicant();
                    }}
                  >
                    Update
                  </Button>
                </GridItem>
              </GridContainer>
              <Clearfix />
              {alert}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
